
  import React from "react"
  import Component from "/home/gitlab-runner/builds/_opy_VqP/0/cw/ws/uvocorp.com/gatsby/src/layouts/index.js"
  import data from "/home/gitlab-runner/builds/_opy_VqP/0/cw/ws/uvocorp.com/gatsby/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js